import { useEffect, useState, useContext } from "react";
import axios from 'axios';

import { UserPlus } from "../../files/icons/index.js";

import { PhysicianAvatar } from "../components/component.js";
import Drop from "./drop.js";

import { AppContext } from '../../context.js';

import { FullName } from '../../utils/string.js';

function PhysicianPicker(props) {
  const { physicianList, physicianID, onChange, onChangeID, leftText, leftIcon, rightIcon, className, dropClassName, disabled = false } = props;

  const context = useContext(AppContext);

  const [loading, setLoading] = useState(true);

  const [physicians, setPhysicians] = useState([]);
  const [selectedPhysician, setSelectedPhysician] = useState(null);

  const [closePhysicianDrop, setClosePhysicianDrop] = useState(0);

  const [searchText, setSearchText] = useState("");

  useEffect(() => {
    if (!loading) {
      if (physicianID) {
        setSelectedPhysician(physicians.find((p) => p.id === physicianID));
      }
      return
    }

    if (physicianList) {
      setPhysicians(physicianList.sort((a, b) => a.firstName.localeCompare(b.firstName)));
      if (physicianID) {
        setSelectedPhysician(physicianList.find((p) => p.id === physicianID));
      }
      setLoading(false);
      return;
    }

    let u = context.addSpiner();
    axios.post('/api/admin/physicians', {
      filter: {}
    }).then((response) => {
      setPhysicians(response.data.physicians.sort((a, b) => a.firstName.localeCompare(b.firstName)));
      if (physicianID) {
        setSelectedPhysician(response.data.physicians.find((p) => p.id === physicianID));
      }
      setLoading(false);
    }).catch((e) => {
      context.addError(e);
      context.removeSpiner(u);
    }).finally(() => {
      context.removeSpiner(u);
    });
  }, [physicianList, physicianID]);

  const handleSearchChange = (e) => {
    setSearchText(e.target.value);
  };

  function renderPhysicians() {
    let filteredPhysicians = physicians.filter((physician) => {
      const fullName = FullName(physician.firstName, physician.middleName, physician.lastName).toLowerCase();
      return fullName.includes(searchText.toLowerCase());
    });

    // Filter Carecierge bot out
    filteredPhysicians = filteredPhysicians.filter((physician) => physician.id !== "000000000000000000000001");

    // Filter archived physicians out
    filteredPhysicians = filteredPhysicians.filter((physician) => physician.statusType === 'ACTIVE');

    if (filteredPhysicians.length === 0) {
      return (
        <div className="side-item small nowrap">
          <span className="typo-normal-150">No physicians found</span>
        </div>
      );
    }

    return filteredPhysicians.map((physician, i) => {
      return (
        <div className="side-item small nowrap" key={i} onClick={() => { onChange(physician, onChangeID); setClosePhysicianDrop(closePhysicianDrop + 1); setSearchText(""); }}>
          <PhysicianAvatar id={physician.id} />
          <span className="typo-normal-150">{FullName(physician.firstName, physician.middleName, physician.lastName) + (physician.speciality ? ' | ' + physician.speciality : '')}</span>
        </div>
      );
    });
  }

  if (loading) {
    return <></>;
  }

  const trigger = (
    <div className={"item grey nowrap " + className} style={disabled ? { opacity: 0.7, cursor: "default" } : undefined}>
      {leftIcon && leftIcon}
      {leftText && <span className="typo-normal-150">{leftText}</span>}
      {selectedPhysician ? (
        <PhysicianAvatar id={selectedPhysician.id} style={{ height: 16, width: 16 }} />
      ) : (
        <UserPlus height={16} width={16} color={'grey'} />
      )}
      <span className="typo-normal-150">{selectedPhysician ? FullName(selectedPhysician.firstName, selectedPhysician.middleName, selectedPhysician.lastName) + (selectedPhysician.speciality ? ' | ' + selectedPhysician.speciality : '') : "Assignee"}</span>
      {!disabled && rightIcon}
    </div>
  );

  if (disabled) {
    return trigger;
  }

  return (
    <Drop close={closePhysicianDrop} className={dropClassName}>
      {trigger}
      <div className="card shadowmore" style={{minWidth: 180, width: 'fit-content'}}>
        <div className="card-content sm" style={physicians.length > 20 ? {height: 300, overflowY: 'auto'} : {}}>
          <input type="text" className="input borderless typo-normal-150 w-100 mb-2" placeholder="Search..." value={searchText} onChange={handleSearchChange} autoFocus={true} />

          {renderPhysicians()}
        </div>
      </div>
    </Drop>
  );
}

export default PhysicianPicker;
